import { Form } from 'react-final-form';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { IncreaseAmount } from '../../../../../components/IncreaseAmount';
import { useCurrentUser } from '../../../../../hooks/selectors';
import { useDispatch } from 'react-redux';
import { snackShow } from '../../../../../actions';
import {
  useIsAlternativeAuction,
  useNoSelectorVehicleOfferAuctionById,
  useOfferAuctionBidsInfo
} from '../../../../../hooks';
import { usePlaceOfferBidMutation } from '../../../../../services/api/offer-auction';
import { auctionOfferStatuses } from '../../../../../utils/statusCalculator';
import { AUCTION_STATUSES, BUYER_VEHICLE_STATUS } from '../../../../../constants';
import { usePlaceAlternativeBidOfferMutation } from 'services/api/alternative-offers';
import { getMinBitAmount } from 'utils/vehicle';

export const IncreaseAlternativeOffer = () => {
  const vehicle = useViewedVehicle();
  const user = useCurrentUser();
  const [placeAlternativeBidOffer] = usePlaceAlternativeBidOfferMutation();
  const dispatch = useDispatch();
  const isAlternativeAuction = useIsAlternativeAuction(vehicle);

  if (!vehicle) return null;
  if (user.role !== 'buyer') return null;

  const minAmount = getMinBitAmount(vehicle, user);

  const status = auctionOfferStatuses(vehicle, null, user);
  const canPlaceOffer =
    isAlternativeAuction &&
    status === BUYER_VEHICLE_STATUS.ACTIVE_ALTERNATIVE_AUCTION &&
    vehicle.auction?.status === AUCTION_STATUSES.ACTIVE;

  if (!canPlaceOffer) {
    return null;
  }

  const onSubmit = async (values: { amount: string }) => {
    const response = await placeAlternativeBidOffer({
      vehicle_id: vehicle.id,
      amount: Number(values.amount)
    });

    if ('data' in response) {
      dispatch(snackShow({ message: 'Offer successfully placed' }));
    } else {
      dispatch(
        snackShow({ type: 'error', message: (response.error as any)?.data?.message || 'Failed to place offer' })
      );
    }
  };

  return (
    <Form onSubmit={onSubmit} initialValues={{ amount: minAmount }} name="increase-alternative-offer">
      {props => <IncreaseAmount isProxyAmount={false} type="offer" initialAmount={minAmount} />}
    </Form>
  );
};
